import './styles/projectCard.css';
import PropTypes from 'prop-types';

/**
 * Component representing a project card.
 * @param {string} accentColor - The accent color for the project card.
 * @param {string} image - The URL of the project image.
 * @param {string} imageAlt - The alternative text for the project image.
 * @param {string} redirect - The URL to redirect to when the card is clicked.
 * @param {string} name - The name of the project.
 * @param {string} description - The description of the project.
 * @returns {JSX.Element} The ProjectCard component.
 */
export default function ProjectCard({accentColor, image, imageAlt, redirect, name, description}) {
    return (
        <a href={redirect} target='_blank' rel='noreferrer' className="project-card-zone cursor-detect-hover" style={{ "--accent-color": accentColor }}>
            <div className="project-card-popup cursor-hoverable">
                <span></span>
            </div>
            <div className="project-card">
                <div className="project-image-wrapper">
                    <img src={image} alt={imageAlt} />
                </div>
                <div className="project-details">
                    <h1>{name}</h1>
                    <p>{description}</p>
                </div>
            </div>
        </a>
    );
};
ProjectCard.propTypes = {
    accentColor: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    imageAlt: PropTypes.string.isRequired,
    redirect: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};